import styled from 'styled-components'

export const Container = styled.div`
  max-width: ${props => props.theme.maxWidth};
  margin: 0 auto;
  padding: 20px 20px;
`

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
`

// https://uxdesign.cc/creating-horizontal-scrolling-containers-the-right-way-css-grid-c256f64fc585
export const ProductList = styled.div`
  position: relative;
  z-index: 0;
  overflow: auto;

  > div {
    display: grid;
    padding: 0 20px;
    grid-gap: 20px;
    grid-template-columns: repeat(6, calc(25% - 20px));
    grid-template-rows: minmax(150px, 1fr);
  }
`
